import { queryCourseDetail } from '@/api'
import { Toast } from 'vant'
import moment from 'moment'
export default {
  components: {},
  props: [],
  name: 'detail-page',
  data () {
    return {
      c: {},
      loading: false,
      courseId: null
    }
  },
  filters: {
    haveSeatFilter (data) {
      return data ? '名额紧张' : '暂无名额'
    },
    suggest (course) {
      let str = ''
      if (course.suggestMaster) { str += '硕士生 ' }
      if (course.suggestCollege) { str += '大学生 ' }
      if (course.suggestSenior) { str += '高中生 ' }
      return str
    },
    levelFilter (data) {
      let buffer = ''
      if (data.level1 || data.level2 || data.level3) {
        if (data.level1) { buffer += '初级' }
        if (data.level2) { buffer += '中级' }
        if (data.level3) { buffer += '高级' }
      } else {
        buffer = '无'
      }

      return buffer
    },
    surplusFilter (data) {
      if (data === -1) { return '招生中' }
      if (data === -2) { return '名额已满' }
      if (data > 0) { return `余${data}位` }
    }
  },
  computed: {
    // x: function() {}
  },
  watch: {
    // x: function(val) {}
  },
  created () {
    const courseId = this.$route.query.id
    if (courseId === undefined || courseId === null || courseId === '') {
      this.$message({ type: 'error', message: '数据错误，请联系管理员检查' })
    } else {
      this.courseId = courseId
    }
    this.initData()
  },
  mounted () {},
  destroyed () {},
  methods: {
    async initData () {
      this.loading = true
      const courseResult = await queryCourseDetail(this.courseId)
      const { data } = courseResult
      this.c = data
      this.loading = false
    },
    copy () {
      console.log(1)
      Toast('链接复制成功，您可以去粘贴了')
    },
    timeFormat (startTime, endTime) {
      if (startTime === null) return '人满开班'
      else if (endTime === null) return moment(startTime).format('MM月DD日')
      else return `${moment(startTime).format('MM月DD日')}—${moment(endTime).format('MM月DD日')}`
    }
  }
}
